<template>
    <v-app>
        <MaskView :show="maskView"/>
        <v-app-bar app class="drei_60-grey">
            <v-toolbar-title class="headline text-uppercase">
                <span>
                    <router-link class="toolbar-title" :to="route.SEARCH.path">360°</router-link>
                </span>
            </v-toolbar-title>
            <v-toolbar-items v-if="isLoggedIn">
                <v-btn v-if="isLeserserviceOrHigher" icon :to="route.SEARCH.path">
                    <v-icon>mdi-magnify</v-icon>
                </v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-items v-if="isLoggedIn && isLeserserviceLeitungOrHigher">
                <v-tooltip left class="flex-none">
                    <template #activator="{ on }">
                        <v-btn
                                v-on="on"
                                small
                                text
                                icon
                                :to="addUser"
                        >
                            <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                    </template>
                    <span>Nutzer anlegen</span>
                </v-tooltip>
            </v-toolbar-items>
            <v-toolbar-items v-if="isLoggedIn">
                <v-menu
                    bottom
                    left
                    :open-on-hover="true"
                    :offset-y="true"
                    v-if="isAdminOrHigher"
                >
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            transition="slide-x-transition"
                            slot="activator"
                            icon
                        >
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item
                            :to="route.APPLICATIONS.path"
                            v-if="isDeveloper"
                        >
                            <v-list-item-title>
                                Applications
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                    <v-list>
                        <v-list-item
                                :to="route.APPLICATION_PERMISSIONS.path"
                                v-if="isAdminOrHigher"
                        >
                            <v-list-item-title>
                                Application Permissions
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                    <v-list>
                        <v-list-item
                                :to="route.DEVTOOL.path"
                                v-if="isAdminOrHigher"
                        >
                            <v-list-item-title>
                                Devtool
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                    <v-list>
                        <v-list-item
                                :to="route.SALESFORCE.path"
                                v-if="isAdminOrHigher"
                        >
                            <v-list-item-title>
                                Salesforce
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn icon @click="logout">
                    <v-icon>mdi-power</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-app-bar>

        <v-content>
            <v-container fluid>
                <router-view :key="$route.fullPath"></router-view>
                <v-snackbar v-model="snack.show" :timeout="snack.timeout" :color="snack.color">
                    {{ snack.message }}
                    <v-btn text @click="snack.show = false">
                        <v-icon small>{{ snack.icon }}</v-icon>
                    </v-btn>
                </v-snackbar>
            </v-container>
        </v-content>
        <v-footer class="pa-3">
            <v-spacer></v-spacer>
            <div><small>&copy; {{ new Date().getFullYear() }} NOZ Digital / mh:n Medien</small></div>
        </v-footer>
    </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Route from '@/route';
import Storage from '@/storage';
import MaskView from '@/components/MaskView.vue';


export default {
    name: 'App',
    components: {
        MaskView,
    },
    data() {
        return {
            route: Route,
        };
    },
    methods: {
        logout() {
            Storage.clearToken();
            this.$router.push({ name: Route.LOGIN.name });
        },
    },
    computed: {
        ...mapGetters(['isDeveloper', 'isLeserserviceLeitungOrHigher', 'isLeserserviceOrHigher', 'isAdminOrHigher']),
        ...mapState([
            'maskView',
            'isLoggedIn',
        ]),
        ...mapState('snackbar', ['snack']),
        addUser() {
            return Route.CUSTOMER_CREATE.path;
        },
    },
};
</script>

<style lang="scss">
    @import "@/style/colors.scss";

    .headline {
        display: flex;
        align-items: center;

        > span {
            padding-left: 1em;
            padding-right: 1em;
        }

        a.toolbar-title {
            text-decoration: none;
            color: $black;
        }
    }
</style>
